import { action } from 'satcheljs/lib/legacy';
export default action('toggleRibbon')(function toggleRibbon(viewState) {
    viewState.isRibbonShown = !viewState.isRibbonShown;
});
//# sourceMappingURL=toggleRibbon.js.map